import { render, staticRenderFns } from "./UpTextbook.vue?vue&type=template&id=12bb90c8&scoped=true&"
import script from "./UpTextbook.vue?vue&type=script&lang=js&"
export * from "./UpTextbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bb90c8",
  null
  
)

export default component.exports